module.exports = __webpack_public_path__ + "static/cover-whale-76f29072bc3cc4fb81e4a12d88b86b5e.mp4";